import KVMViewer from "modus/components/misc/KVMViewer";
import React from "react";
import { formatTargetCloudProviderLabel } from "../config/deploymentRegions";
import { DeploymentStatusBadge, DeploymentStatusKeyType } from "./DeploymentStatusBadge";
import { getResolvedEnv } from "./EnvBadge";
import { DeploymentEditor } from "./DeploymentEditor";

interface DeploymentDetailsRegionalProps {
  targetRegion?: string;
  targetProvider?: string;
  gatewayRegion?: string;
  targetEndpoint?: string;
  deployedEndpoint?: string;
  timeout?: string;
  deploymentStatus?: string;
  deploymentId?: string;
  serviceId: string;
  refreshDeployments?: () => void;
  onDeploymentUpdated?: () => void;
}

/** Figma-style KVM: Target region, API gateway, Backend API URL, etc. */
export const DeploymentDetailsRegional: React.FC<DeploymentDetailsRegionalProps> = (
  props
) => {
  const gatewayRegionLabel = props?.gatewayRegion
    ? getResolvedEnv(props.gatewayRegion)
    : "—";

  const targetProviderLabel = formatTargetCloudProviderLabel(props?.targetProvider);
  const targetRegionKey = props?.targetRegion;
  const regionHuman = targetRegionKey ? getResolvedEnv(targetRegionKey) : "";
  const targetRegionDisplay =
    targetProviderLabel && regionHuman
      ? `${targetProviderLabel} | ${regionHuman}`
      : regionHuman || "—";

  return (
    <KVMViewer
      dataList={{
        "Target region": targetRegionDisplay,
        "API gateway": gatewayRegionLabel,
        "Backend API URL": props?.targetEndpoint ?? "—",
        "Deployed Endpoint": props?.deployedEndpoint,
        "Connection Timeout":
          props?.timeout === "1"
            ? "1 second"
            : `${props?.timeout ?? "—"} seconds`,
        "Deployment Status": (
          <DeploymentStatusBadge
            status={props?.deploymentStatus as DeploymentStatusKeyType}
          />
        ),
      }}
      controls={
        <DeploymentEditor
          updateDeployment={{
            isUpdate: true,
            serviceId: props?.serviceId,
            deploymentId: props?.deploymentId,
            targetEndpoint: props?.targetEndpoint,
            deployedEndpoint: props?.deployedEndpoint,
            timeout: parseInt(props?.timeout || "30"),
            region: props?.gatewayRegion,
            targetRegion: props?.targetRegion,
            targetProvider: props?.targetProvider,
            gatewayRegion: props?.gatewayRegion,
            refreshDeployments: props.refreshDeployments,
            deploymentStatus: props?.deploymentStatus,
          }}
          onDeploymentUpdated={props?.onDeploymentUpdated}
        />
      }
    />
  );
};
